<h1 mat-dialog-title>{{ data.dialogTitle }}</h1>
<div mat-dialog-content *ngIf="isLoading">Loading Data, Please Wait...</div>
<div mat-dialog-content *ngIf="!isLoading">
  <form class="edit-interactive-subscription-dialog-form">
    <mat-form-field>
      <mat-label>Name (required, unique, 40 character max)</mat-label>
      <input
        matInput
        name="data.interactSubTypeName"
        [(ngModel)]="data.interactSubTypeName"
      /> </mat-form-field
    ><br />
    <mat-form-field>
      <mat-label>Description (required)</mat-label>
      <input
        matInput
        name="data.description"
        [(ngModel)]="data.description"
      /> </mat-form-field
    ><br />
    <mat-label>Interactives (min 1 required)</mat-label>
    <div class="endpoint-list-container">
      <mat-checkbox
        *ngFor="let interactive of data.interactives"
        [checked]="isInteractiveSelected(interactive)"
        (change)="toggleInteractive(interactive)"
      >
        {{ interactive.interactName }}
      </mat-checkbox>
    </div>
    <ng-container>
      <b>NOTE: </b> Selecting NO API endpoints allows access to ALL API endpoints when subscription level has API access.
    </ng-container><br />
    <mat-label>API End Points</mat-label>
    <div class="endpoint-list-container">
      <mat-checkbox
        *ngFor="let endPoint of data.apiEndPoints"
        [checked]="isApiEndPointSelected(endPoint)"
        (change)="toggleApiEndPoint(endPoint)"
      >
        {{ endPoint.apiEndPointPath }}
      </mat-checkbox>
    </div>
    <mat-label>Data on Demand End Points</mat-label>
    <div class="endpoint-list-container">
      <mat-checkbox
        *ngFor="let endPoint of data.endPoints"
        [checked]="isEndPointSelected(endPoint)"
        (change)="toggleEndPoint(endPoint)"
      >
        {{ endPoint.title }}
      </mat-checkbox>
    </div>
    <ng-container>
      <button mat-raised-button color="primary" (click)="editLicense()">
        Edit License
      </button> </ng-container
    ><br />
    <!--<mat-form-field>
      <mat-label>Restrict purchase to following emails:</mat-label>
      <input
        matInput
        name="ToAddEmail"
        [(ngModel)]="ToAddEmail"
      /> </mat-form-field
    ><br />
    <ng-container>
      <button mat-raised-button color="primary" (click)="addRestrictedEmail()">
        Add Email
      </button> </ng-container
    ><br />
    <mat-form-field>
      <mat-chip-list #restrictedEmailChipLIst>
        <mat-chip
          *ngFor="let isb of data.restrictPurchaseEmails"
          [removable]="removable"
          (removed)="onRemoveEmail(isb)"
        >
          {{ isb }}
          <mat-icon matChipRemove>x</mat-icon>
        </mat-chip>
      </mat-chip-list> </mat-form-field
    ><br />-->
  </form>
</div>
<div mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="onConfirmClick()">
    Save Subscription
  </button>
  <button mat-raised-button (click)="onCancelClick()">Cancel</button>
</div>
